<div class="flex-fill layout-row-wrap gap-2percent layout-lt-md-column">
  <h4 class="m-b-15 right flex-90">
    {{ 'labels.heading.You can drag and drop the rows to set a Payment Allocations order' | translate }}
  </h4>

  @if (!isDefault()) {
    <div class="right flex-4">
      <button mat-button color="warn" (click)="removeTransaction()">
        <fa-icon icon="trash" class="m-r-10"></fa-icon>
      </button>
    </div>
  }

  @if (paymentAllocationsData) {
    <div class="mat-elevation-z8 container m-t-15">
      <table
        mat-table
        [dataSource]="paymentAllocationsData"
        #table
        cdkDropList
        [cdkDropListData]="paymentAllocationsData"
        (cdkDropListDropped)="dropTable($event, false)"
      >
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let paymentAllocation">
            <fa-icon icon="bars"></fa-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="order">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Order' | translate }}</th>
          <td mat-cell *matCellDef="let paymentAllocation; let rowIndex = index">{{ rowIndex + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="allocationRule">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Payment Allocation Rule' | translate }}</th>
          <td mat-cell *matCellDef="let paymentAllocation">{{ paymentAllocation.value | translateKey: 'catalogs' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row cdkDrag [cdkDragData]="row" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }

  @if (creditAllocationsData) {
    <div class="mat-elevation-z8 container m-t-15 m-b-15">
      <table
        mat-table
        [dataSource]="creditAllocationsData"
        #table
        cdkDropList
        [cdkDropListData]="creditAllocationsData"
        (cdkDropListDropped)="dropTable($event, true)"
      >
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let creditAllocation">
            <fa-icon icon="bars"></fa-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="order">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Order' | translate }}</th>
          <td mat-cell *matCellDef="let creditAllocation; let rowIndex = index">{{ rowIndex + 1 }}</td>
        </ng-container>
        <ng-container matColumnDef="allocationRule">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Credit Allocation Rule' | translate }}</th>
          <td mat-cell *matCellDef="let creditAllocation">{{ creditAllocation.value | translateKey: 'catalogs' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row cdkDrag [cdkDragData]="row" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }

  @if (advancedPaymentAllocation && advancedPaymentAllocation.futureInstallmentAllocationRules) {
    <mat-form-field class="m-t-20 flex-33">
      <mat-label>{{ 'labels.inputs.Future Installment Allocation Rule' | translate }}</mat-label>
      <mat-select [formControl]="futureInstallmentAllocationRule">
        @for (
          futureInstallmentAllocationRule of advancedPaymentAllocation.futureInstallmentAllocationRules;
          track futureInstallmentAllocationRule
        ) {
          <mat-option [value]="futureInstallmentAllocationRule.code">
            {{ futureInstallmentAllocationRule.value | translateKey: 'catalogs' }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
